/**
 * Card Component
 * Generic card wrapper component with title, actions, and content.
 */

import type { ReactNode } from 'react';
import styles from './Card.module.css';

interface CardProps {
  /** Card title */
  title?: string;
  /** Optional actions to display in the header */
  actions?: ReactNode;
  /** Card content */
  children: ReactNode;
  /** Optional additional class name */
  className?: string;
  /** Optional header class name */
  headerClassName?: string;
  /** Optional content class name */
  contentClassName?: string;
  /** Remove padding from content */
  noPadding?: boolean;
}

export const Card = ({
  title,
  actions,
  children,
  className = '',
  headerClassName = '',
  contentClassName = '',
  noPadding = false,
}: CardProps) => {
  const cardClasses = [styles.card, className].filter(Boolean).join(' ');
  const contentClasses = [
    styles.content,
    noPadding ? styles.noPadding : '',
    contentClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cardClasses}>
      {(title || actions) && (
        <div className={[styles.header, headerClassName].filter(Boolean).join(' ')}>
          {title && <h3 className={styles.title}>{title}</h3>}
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      )}
      <div className={contentClasses}>{children}</div>
    </div>
  );
};
